import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import Drawer from "@material-ui/core/Drawer/index";
import Divider from "@material-ui/core/Divider/index";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card/index";
import CardHeader from "@material-ui/core/CardHeader/index";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "react-bootstrap";
import {FaFingerprint,FaRegCreditCard} from "react-icons/fa"
const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#231B88",
  },
});

export default function View(props) {
  const { open, onClose, onFingerLimitChoose, chooseFingerLimitId } = props;
  const [fingerLimit, setFingerLimit] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fullName ,cardLimit,fingerprint} = fingerLimit;

  useEffect(() => {
    setIsLoading(true);
    onFingerLimitChoose(chooseFingerLimitId)
      .then((res) => {
        setFingerLimit(res.data);
        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [chooseFingerLimitId, onFingerLimitChoose]);

  const classes = useStyles();


  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">İstifadəçi kartları və barmaq izi detalları</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />

      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading && !isError ? (
        <div className="drawer-body">
          <Card className={classes.card}>
            <CardHeader
              title="Ümumi informasiya"
              className="bg-secondary text-dark h6 p-3"
              disableTypography
            />
            <CardHeader
              avatar={
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Address-card.svg"
                  )}
                  className="icon-primary"
                />
              }
              title={fullName ? fullName:"-"}
              subheader="A.S.A"
              className="p-3"
            />
            
            <CardHeader
              avatar={
              <FaRegCreditCard   className="icon-primary"/>
              }
              title={cardLimit ? cardLimit:"-"}
              subheader="Kart limiti"
              className="p-3"
            />
            <CardHeader
              avatar={
                <FaFingerprint     className="icon-primary"/>
              
              }
              title={fingerprint ? fingerprint:"-"}
              subheader="Barmaq izi"
              className="p-3"
            />
          
       
 
          </Card>
        </div>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </div>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      className="drawer--fixed"
    >
      {sideList("right")}
    </Drawer>
  );
}
